import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/order-service/v1'

/** -------------------------- 量产-订单管理 start  --------------------------*/
//采购端获取订单数据
export function fetchOrderList(params) {
    return post(SERVICE_URL + '/orderTbl/list', params)
}
//供应商端获取订单数据
export function fetchOrderList4Supplier(params) {
    return post(SERVICE_URL + '/orderTbl/list4Supplier', params)
}
export function deleteOrder(params, pathParam) {
    return get(SERVICE_URL + '/orderTbl/deleteBatch', params, pathParam)
}
export function createOrder(params) {
    return post(SERVICE_URL + '/orderTbl/add', params)
}

export function getOrderById(params, pathParam) {
    return get(SERVICE_URL + '/orderTbl/getById', params, pathParam)
}
//采购端获取采购组
export function getGroupList(params) {
    return post(SERVICE_URL + '/orderTbl/getGroupList', params)
}
// 供应商端获取采购组
export function getGroupList4Supplier(params) {
    return post(SERVICE_URL + '/orderTbl/getGroupList4Supplier', params)
}
export function getGroupListBySupplierCode(params) {
    return post(SERVICE_URL + '/orderTbl/getGroupListBySupplier', params)
}
export function editOrder(params) {
    return post(SERVICE_URL + '/orderTbl/edit', params)
}

export function confirmOrder(pathParam) {
    return post(SERVICE_URL + '/orderTbl/confirm/' + pathParam)
}
export function publishOrder(params) {
    return post(SERVICE_URL + '/orderTbl/publishOrder', params)
}
//提交审批
export function approve(params) {
    return post(SERVICE_URL + '/orderTbl/approve', params)
}
//获取当前用户数据权限
export function getCurrentUserDataAuthority(params) {
    return post(SERVICE_URL + '/orderTbl/getCurrentUserDataAuthority', params)
}
/** -------------------------- 量产-订单管理 end  --------------------------*/

/** -------------------------- 量产-零件管理 start -------------------------- */
export function getOrderTblPartList(params) {
    return post(SERVICE_URL + '/orderPart/list', params)
}

export function getPartById(params, pathParam) {
    return get(SERVICE_URL + '/orderPart/getById', params, pathParam)
}

export function editOrderPart(params) {
    return post(SERVICE_URL + '/orderPart/edit', params)
}

export function createOrderPart(params) {
    return post(SERVICE_URL + '/orderPart/add', params)
}

export function deletePart(params) {
    return post(SERVICE_URL + '/orderPart/deleteBatch', params)
}

export function getStreetList(params) {
    return post(SERVICE_URL + '/orderPart/getStreetList', params)
}
// /** 供应商管理 */

export function getSupplierList(params) {
    return post(SERVICE_URL + '/supplier/list', params)
}

/** 导出管理 */
export function exportOrderDataList(params) {
    return post(SERVICE_URL + '/upload-file/export-order', params)
}

/** 导出管理 */
export function exportOrderDataList4Supplier(params) {
    return post(SERVICE_URL + '/upload-file/export-order-4Supplier', params)
}
/** -------------------------- 量产-零件管理 end -------------------------- */



/** -------------------------- 样件-订单管理 start -------------------------- */
export function fetchOrderOtsList(params) {
    return post(SERVICE_URL + '/order-ots/list', params)
}
export function getOrderOtsById(params, pathParam) {
    return get(SERVICE_URL + '/order-ots/getById', params, pathParam)
}
export function getOrderOtsPartList(params) {
    return post(SERVICE_URL + '/order-ots-part/list', params)
}
export function exportOrderOtsDataList(params) {
    return post(SERVICE_URL + '/upload-file/export-order-ots', params)
}
export function getGroupOtsList(params) {
    return post(SERVICE_URL + '/order-ots/getGroupList', params)
}
export function getGroupOtsListBySupplierCode(params) {
    return post(SERVICE_URL + '/order-ots/getGroupListBySupplier', params)
}
export function fetchOrderOtsListBySupplier(params) {
    return post(SERVICE_URL + '/order-ots/list-supplier', params)
}
export function confirmOrderOts(pathParam) {
    return post(SERVICE_URL + '/order-ots/confirm/' + pathParam)
}
export function selectPart(params) {
    return post(SERVICE_URL + '/order-ots-part/list-street', params)
}
export function selectPartBySupplier(params) {
    return post(SERVICE_URL + '/order-ots-part/list-street-supplier', params)
}

/** -------------------------- 样件-订单管理 end -------------------------- */

/** -------------------------- 创建交货单时，选择物料中查看订单信息 -------------------------- */
export function getDeliveryOrderTblPartList(params) {
    return post(SERVICE_URL + '/orderPart/orderPartList', params)
}


